import React from 'react';
import styles from "../../../styles/components/UI/Custom/AddButton.module.css";


export const AddButton = ({ text, onClick }) => {
  return (
    <div className={styles.addButtonContainer}>
        <button className={styles.addButton} onClick={onClick}>
            <p className={styles.addButtonText}>{text}</p>
        </button>
    </div>
  );
};